import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Customer } from "../../models/User";
import { UserService } from "../../services/userService";
import { DocumentService } from "../../services/documentService";

export interface CustomerState {
  customers: Customer[];
  errors: string | null;
  loading: boolean;
}

const initialState: CustomerState = {
  customers: [], // Initialize as an empty array
  errors: null,
  loading: false,
};

export const getAllCustomers = createAsyncThunk<Customer[]>(
  "customer/all",
  async () => {
    const res = await UserService.getAllCustomers();
    return res.data; // Assume res.data is an array of Customer objects
  }
);

export const validateDocument = createAsyncThunk(
  "document/validate",
  async (
    { customerId, documentId }: { customerId: string; documentId: string },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const res = await DocumentService.validateDocument(
        customerId,
        documentId
      );
      return res;
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to validate document";
      return rejectWithValue(errorMessage);
    }
  }
);
export const rejectDocument = createAsyncThunk(
  "document/reject",
  async (
    {
      customerId,
      documentId,
      reason,
    }: { customerId: string; documentId: string; reason: string },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const res = await DocumentService.rejectDocument(
        customerId,
        documentId,
        reason
      );
      return res;
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to reject document";
      return rejectWithValue(errorMessage);
    }
  }
);

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCustomers.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(getAllCustomers.fulfilled, (state, action) => {
        state.customers = action.payload;
        state.loading = false;
        state.errors = null;
      })
      .addCase(getAllCustomers.rejected, (state, action) => {
        state.loading = false;
        state.errors = action.error.message || "Failed to fetch customers";
      });
  },
});

export default customerSlice.reducer;
